import { render, staticRenderFns } from "./PT080CategoryHeadlineParts.vue?vue&type=template&id=809bcc48&"
import script from "./PT080CategoryHeadlineParts.vue?vue&type=script&lang=js&"
export * from "./PT080CategoryHeadlineParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports